<template>
	<div class="phhonor-hea">
		<div class="phhonorhea-left">
			<img :src="$store.state.phLogoImage" v-if="$store.state.phLogoImage"/>
		</div>
		<div class="phhonorhea-right" @click="navtomore">
			<img src="../assets/phaboutimg/phaboutmenu.png" />
		</div>
	</div>
</template>

<script>
import { session } from "./../storage/storage.js";
	export default{
		data(){
			return{
				
			}
		},
		mounted(){
			let channel_id = session.get("channel_id") == '' ? 1 : session.get("channel_id")
			let data= {
				mold: "h5",
				lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
				channel_id: channel_id
			};
			this.$api.get_channel_index(data).then((res) => {
				this.$store.commit('setphLogoImage',res.data.logo_image)
				if(channel_id == 1){
					this.$store.commit('setthemeColor','#e62129')
					this.$store.commit('setBrand','woodpecker')
				}else if(channel_id == 2){
					this.$store.commit('setthemeColor','#1a4698')
					this.$store.commit('setBrand','dte')
				}else{
					this.$store.commit('setthemeColor','#5f5d5d')
					this.$store.commit('setBrand','dba')
				}
			});
		},
		methods:{
			navtomore(){
				this.$router.push({path: '/phmore'})
			},
			setHeaderStyle(){
				let channel_id = session.get("channel_id") == '' ? 1 : session.get("channel_id")
				let data= {
					mold: "h5",
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: channel_id
				};
				this.$api.get_channel_index(data).then((res) => {
					this.$store.commit('setphLogoImage',res.data.logo_image)
					if(channel_id == 1){
						this.$store.commit('setthemeColor','#e62129')
						this.$store.commit('setBrand','woodpecker')
					}else if(channel_id == 2){
						this.$store.commit('setthemeColor','#1a4698')
						this.$store.commit('setBrand','dte')
					}else{
						this.$store.commit('setthemeColor','#000')
						this.$store.commit('setBrand','dba')
					}
				});
			}
		}
	}
</script>

<style>
	.phhonor-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}
	.phhonorhea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
		display: flex;
		
	}
	.phhonorhea-left img{
		width: 0.97rem;
		height: 0.5rem;
	}
	.phhonorhea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
		display: flex;
	}
	.phhonorhea-right img{
		width: 0.38rem;
		height: 0.38rem;
	}
</style>
